import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';

const shouldShowAmount = amount => amount && parseFloat(amount) > 0;

function TaxesAndFeesHelpText({
  tax,
  serviceFee,
  customFee,
  customFeeName,
  bundleServiceFeeWithCustomFee,
  bundledServiceAndCustomFees
}) {
  const customFeeAmount = bundleServiceFeeWithCustomFee
    ? bundledServiceAndCustomFees
    : customFee;

  const styles = { variant: ITEM_DESCRIPTION_AND_PRICES };

  return (
    <React.Fragment>
      {shouldShowAmount(tax) && (
        <Typography
          {...styles}
          data-testid="tooltip-tax"
          component="h6"
          sx={{ fontSize: 14 }}
        >
          Tax: ${tax}
        </Typography>
      )}
      {!bundleServiceFeeWithCustomFee && shouldShowAmount(serviceFee) && (
        <Typography
          {...styles}
          data-testid="tooltip-service-fee"
          component="h6"
          sx={{ fontSize: 14 }}
        >
          Service Fee: ${serviceFee}
        </Typography>
      )}
      {shouldShowAmount(customFeeAmount) > 0 && (
        <Typography
          {...styles}
          data-testid="tooltip-custom-fee"
          component="h6"
          sx={{ fontSize: 14 }}
        >
          {customFeeName}: ${customFeeAmount}
        </Typography>
      )}
    </React.Fragment>
  );
}

TaxesAndFeesHelpText.propTypes = {
  tax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  serviceFee: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  customFee: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  customFeeName: PropTypes.string,
  bundleServiceFeeWithCustomFee: PropTypes.bool,
  bundledServiceAndCustomFees: PropTypes.string
};

export default TaxesAndFeesHelpText;
